import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/gif/wheel_spinner_loading.gif'


const _hoisted_1 = { class: "loading-container" }
const _hoisted_2 = {
  ref: "gifImage",
  src: _imports_0,
  alt: "cartoon porsche driving",
  class: "loading-img"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "loading-title" }, "2026 PCA Parade", -1)),
    _createElementVNode("img", _hoisted_2, null, 512),
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "loading-caption" }, "loading...", -1))
  ]))
}